const config = {
  baseUrl: "https://api.linksroom.me",
  title: "Links room",
  description: "Lorem epson",
  isDevelopment: process.env.NODE_ENV !== "production",
  pageSize: 25,
  loadingLength: 5,
  googlePlayUrl:
    "https://play.google.com/store/apps/details?id=com.link.linkroom",
  appStoreUrl: "https://apple.co/3ExnCZW",
  webAppUrl: "https://app.linksroom.me",
  supportUs: "https://producthunt.com",
  termUrl: "/terms",
  privacyUrl: "/privacy",
  contactUsUrl: "mailto:gataastudio@gmail.com",
};
export default config;
